import { getTips as getTipsAPI } from '../api/tips'
import { setTips } from '../state/slices/tips_slice'
import { useAppDispatch } from './state'
export const useTips = () => {
  const dispatch = useAppDispatch()

  const getTips = async () => {
    const result = await getTipsAPI()

    if (result.data) {
      dispatch(setTips(result.data))
    }
  }

  return {
    getTips
  }
}

export default useTips
